export const ONBOARDING_QUERY_KEYS = {
  ADMIN_INITIAL_FLOW: 'adminInitialFlow',
  ACCOUNTING_CODES_LIST: 'onboardingAccountingCodesList',
  ACCOUNTING_CODES_DROPDOWN: 'onboardingAccountingCodesDropdown',
  RESOURCE_TEMPLATES: 'onboardingResourceTemplates',
  RESOURCE_TYPE_DROPDOWN: 'onboardingResourceTypeDropdown',
  TRACKING_CATEGORIES: 'onboardingTrackingCategories',
  TENANT_ONBOARDING: 'tenantOnboarding',
  TENANT_ONBOARDING_SKIPPED: 'tenantOnboardingSkipped',
  PO_AUTOGEN_RULE: 'onboardingPoAutogenRule',
  EMPLOYEE_LIST: 'onboardingEmployeeList',
  EMPLOYEE_RESOURCE_CODES: 'onboardingEmployeeResourceCodes',
  EMPLOYEE_RATE_SHEET: 'onboardingEmployeeRateSheet',
};
